import styled from 'styled-components'
import Navbar  from'./navbar.jsx';
import Navigation from './navigation.jsx'
import { useEffect } from 'react';
import { Outlet,useNavigate } from 'react-router-dom'
import { useDispatch,useSelector } from 'react-redux'
import { usuariosRedux } from '../redux/actions/usuarioActions.js'
import { reventasRedux } from '../redux/actions/reventaActions.js'
import { juegosRedux } from '../redux/actions/juegoActions.js'
import { solicitudesRedux} from '../redux/actions/solicitudActions.js'
import { categoriasRedux} from '../redux/actions/categoriaActions.js'
import { solicitudesCompraRedux } from '../redux/actions/solicitudCompraActions.js'
import api from '../axios.js'

const Container=styled.div`
	width:100vw;
	height:100vh;
	overflow:hidden;
	font-family: "Poppins", sans-serif;
 `;


 export default function Home(){
 	let dispatch=useDispatch();
 	let estadoUsuario=useSelector(state=>state.usuario.estadoUsuario);
 	let estadoJuego=useSelector(state=>state.juego.estadoJuego);
 	let reventasEstado=useSelector(state=>state.reventa.reventasEstado);
 	let solicitudEstado=useSelector(state=>state.solicitud.estadoSolicitud);
 	let estadoSolicitudCompra=useSelector(state=>state.solicitudCompras.estadoSolicitudCompra);
 	let estadoCategoria=useSelector(state=>state.categoria.categoriasEstado);
  	let userActive=useSelector(state=>state.login);
 	let navigate=useNavigate();

 	useEffect(()=>{
 		if(!userActive.login&&!(userActive.user.tipo===2||userActive.user.tipo===1)){navigate("/")}
 	},[navigate,userActive.login,userActive.user.tipo])
 	
 	


 	useEffect(()=>{
 		if(estadoUsuario===0&&userActive.login&&(userActive.user.tipo===2||userActive.user.tipo===1) ){
 			try{
 	 			api.get(`/usuario`)
 	 			.then(response=>dispatch(usuariosRedux(response.data)));
 	 		}catch(err){console.log(err)}
 	 } 
 	},[estadoUsuario,dispatch,userActive.login,userActive.user.tipo]);

 	useEffect(()=>{
 		if(reventasEstado===0&&userActive.login&&(userActive.user.tipo===2||userActive.user.tipo===1)){
 			try{	
	 	 		api.get(`/reventa`)
	 	 		.then(response=>dispatch(reventasRedux(response.data))); 	 	
	 	 	}catch(err){console.log(err)}
 	 	} 
 	},[reventasEstado,dispatch,userActive.login,userActive.user.tipo]);

 	useEffect(()=>{
 		if(estadoJuego===0&&userActive.login&&(userActive.user.tipo===2||userActive.user.tipo===1)){
 			try{
	 	 		api.get(`/juego`)
	 	 		.then(response=>dispatch(juegosRedux(response.data)))
	 	 	}catch(err){console.log(err)}
 	 	}
 	},[estadoJuego,dispatch,userActive.login,userActive.user.tipo]);

	/*useEffect(()=>{
 		if(solicitudEstado===0&&userActive.login&&(userActive.user.tipo===2||userActive.user.tipo===1)){
 			try{
	 	 		api.get(`/solicitud`)
	 	 		.then(response=>{dispatch(solicitudesRedux(response.data))});

	 	 	}catch(err){console.log(err)}
 	 	}
 	},[solicitudEstado,dispatch,userActive.login,userActive.user.tipo]);


 	useEffect(()=>{
 		if(estadoSolicitudCompra===0&&userActive.login&&(userActive.user.tipo===2||userActive.user.tipo===1)){
 			try{
	 	 		api.get(`/solicitudCompra`)
	 	 		.then(response=>{dispatch(solicitudesCompraRedux(response.data))});
	 	 	}catch(err){console.log(err)}
 	 	}
 	},[estadoSolicitudCompra,dispatch,userActive.login,userActive.user.tipo]);

*/
 	useEffect(()=>{
 		if(estadoJuego===0&&userActive.login&&(userActive.user.tipo===2||userActive.user.tipo===1)){
 			try{
	 	 		api.get(`/categoria`)
	 	 		.then(response=>dispatch(categoriasRedux(response.data)))
	 	 	}catch(err){console.log(err)}
 	 	}
 	},[estadoJuego,dispatch,userActive.login,userActive.user.tipo]);

 	useEffect(()=>{
 		if(estadoCategoria===0&&userActive.login&&(userActive.user.tipo===2||userActive.user.tipo===1)){
 			try{
	 	 		api.get(`/categoria`)
	 	 		.then(response=>dispatch(categoriasRedux(response.data)))
	 	 	}catch(err){console.log(err)}
 	 	}
 	},[estadoCategoria,dispatch,userActive.login,userActive.user.tipo]);


 	return(
 		<Container>
 			<Navbar navigation={<Navigation/>}/>
 			<Outlet/>
 		</Container>
 		)
 }